<header class="registration-header">
  @if (!isMobileWebView) {
    <div class="logo-row">
      <app-registration-header-logo />
      <lib-lang-dropdown
        (itemSelectedChange)="changeLanguage($event.value)"
        [languages]="languages"
        [itemSelected]="browserLanguage ? browserLanguage : fallbackLanguage"
      />
    </div>
  }

  <div class="step-counter-row">
    @if (!hideStepCounter) {
      <app-registration-step-counter
        [currentStep]="currentStep"
        [totalSteps]="totalSteps"
      />
    }

    @if (!isMobileWebView) {
      <lib-lang-dropdown
        class="step-counter-row__language-menu"
        [languages]="languages"
        (itemSelectedChange)="changeLanguage($event.value)"
        [itemSelected]="browserLanguage ? browserLanguage : fallbackLanguage"
      />
    }
  </div>
</header>
